<template>
    <div class="container">
        <loading-spinner></loading-spinner>
    </div>
</template>

<script>
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'

    export default {
        components: {LoadingSpinner}
    }
</script>
